module.exports = __webpack_public_path__ + "static/media/user-location.1f16090d.svg";